export const FAQ_SCENES = {
  FAQ: 'faq',
  GOOGLE_WALLET: 'googleWallet',
  SHARE_COUPONS: 'shareCoupons',
  RESTAURANT_SOCIAL_MGM: 'restaurantSocialMgm',
} as const

export type KnownFaqScene = typeof FAQ_SCENES[keyof typeof FAQ_SCENES]

export interface ParagraphBlock {
  readonly type: 'paragraph';
  readonly text: string;
}

export interface ListBlock {
  readonly type: 'list';
  readonly items: readonly string[];
}

export interface OrderedListBlock {
  readonly type: 'ordered-list';
  readonly items: readonly string[];
}

export interface TableBlock {
  readonly type: 'table';
  readonly headers: readonly string[];
  readonly rows: readonly (readonly string[])[];
}

export interface RelatedLink {
  readonly text: string;
  readonly url: string;
}

export interface RelatedBlock {
  readonly type: 'related';
  readonly links: readonly RelatedLink[];
}

export type FaqContentBlock =
  | ParagraphBlock
  | ListBlock
  | OrderedListBlock
  | TableBlock
  | RelatedBlock

export interface FaqEntry {
  readonly id: string;
  readonly question: string;
  readonly answer: string;
  readonly blocks?: readonly FaqContentBlock[];
}

export interface FaqGroup {
  readonly prefix?: string;
  readonly id: string;
  readonly title: string;
  readonly scenes: readonly string[];
  readonly items: readonly FaqEntry[];
}

export interface FaqData {
  readonly groups: readonly FaqGroup[];
}

export interface FaqCategory {
  readonly id: string;
  readonly title: string;
  readonly items: readonly FaqEntry[];
}

export interface PageFaqItem {
  readonly id: string;
  readonly question: string;
  readonly answer: string;
}

export interface PageFaqGroup {
  readonly id: string;
  readonly title: string;
  readonly items: readonly PageFaqItem[];
}

export interface SchemaAnswer {
  readonly '@type': 'Answer';
  readonly text: string;
}

export interface SchemaQuestion {
  readonly '@type': 'Question';
  readonly name: string;
  readonly acceptedAnswer: SchemaAnswer;
}

export interface SchemaFaqPage {
  readonly '@context': 'https://schema.org';
  readonly '@type': 'FAQPage';
  readonly mainEntity: readonly SchemaQuestion[];
}

export interface FaqValidationIssue {
  readonly code: string;
  readonly path: string;
  readonly message: string;
  readonly groupId?: string;
  readonly itemId?: string;
  readonly blockType?: string;
}
